import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import ColdChainTransportation from './ColdChainTransportation';
import PrimaryTransportation from './PrimaryTransportation';
import ProjectSpecializTransportation from './ProjectSpecializTransportation';
import SecondaryTransportation from './SecondaryTransportation';


const FleetTransportations = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
    return(
        <div>
            <div id='international' className="fleet-transportation-image">
                <img src='/fleet-transportation/Fleet-&-Trans-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  lg:pb-[50px]  pb-[1rem]">
                <p>
                    TCS is currently maintaining a fleet of over 4,500 vehicles, covering approximately 
                    2.5 million kilometres per month, with a workforce of more than 1,200 drivers and support staff. 
                    National Energy Conservation Centre (ENERCON), Government of Pakistan, has declared TCS as the 
                    ‘Best Fleet Management Company of Pakistan’.
                </p>
                <p>
                    TCS is the 3rd largest satellite-tracked, fleet management company in Pakistan. 
                    We are maintaining an outstanding safety record by following global standards of safety procedures. 
                    We know what it takes to master the roads and the machines. TCS has an ever-expanding fleet of technologically 
                    advanced and well-maintained primary and secondary logistics vehicles, with expertise in fleet 
                    management for the corporate sector of the country as well.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="sm:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/fleet-transportation/primary-transportation"  className='font-bold'>Primary Transportation</Link></li>
                            </div>
                            

                            <div className="flex items-center">
                                <li><Link to="/fleet-transportation/cold-chain-transportation" className='font-bold'>Cold Chain Management</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/fleet-transportation/secondary-transportation" className='font-bold'>Secondary Transportation</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/fleet-transportation/project-sepecializ-transportation" className='font-bold'>Project Specialised Transportation</Link></li>
                            </div>
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="primary-transportation">
                <PrimaryTransportation/>
            </div>
            <div id="secondary-transportation">
                <SecondaryTransportation/>
            </div>
            <div id="cold-chain-transportation">
                <ColdChainTransportation/>
            </div>
            <div id="project-sepecializ-transportation">
                <ProjectSpecializTransportation/>
            </div>
            </div>
        </div>
    )
};
export default FleetTransportations ;